module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ie-1b0ac4e772c2e62aef2f4646a46ab03f.svg";